import { AdobePageName } from '@shared/types/adobe-analytics';
import urlData from '@shared/utilities/routes';

export function GetAdobeNameForPath() {
    switch (window.location.pathname) {
        case urlData.home.mfeLink:
            return AdobePageName.homepage;
        case urlData.about.mfeLink:
            return AdobePageName.aboutUs;
        case urlData.myList.mfeLink:
            return AdobePageName.myList;
        case urlData.vdp.mfeLink:
            return AdobePageName.vdp;
        case urlData.myTransactions.mfeLink:
            return AdobePageName.myTransactions;
        case urlData.myProfile.mfeLink:
            return AdobePageName.myProfile;
        case urlData.policy.mfeLink:
            return AdobePageName.policy;
        case urlData.faq.mfeLink:
            return AdobePageName.faq;
        case urlData.search.mfeLink:
            return AdobePageName.search;
        case urlData.locations.mfeLink:
            return AdobePageName.locations;
        case urlData.checkin.mfeLink:
            return AdobePageName.checkin;
        case urlData.checkout.mfeLink:
            return AdobePageName.checkout;
        default:
            window.location.pathname;
    }
}

export function parseBadgeLabel(badgeLabel: string): { label: string; visibility: string } {
    const [label, visibility] = badgeLabel.split(':');
    return { label, visibility };
}
